(function () {
  const cfg = window.ZaksTheme || {};

  function isOpenNow() {
    const h = new Date().getHours();
    const from = Number(cfg.openFrom ?? 12);
    const to = Number(cfg.openTo ?? 22);
    return h >= from && h < to;
  }

  function formatHour(hour) {
    const h = Number(hour);
    if (!Number.isFinite(h)) return '';
    const ampm = h >= 12 ? 'pm' : 'am';
    const h12 = h % 12 || 12;
    return h12 + ampm;
  }

  function syncStatus() {
    const open = isOpenNow();
    document.documentElement.classList.toggle('store-open', open);
    document.documentElement.classList.toggle('store-closed', !open);

    document.querySelectorAll('[data-store-status]').forEach((el) => {
      el.textContent = open ? 'Open' : 'Closed';
      el.classList.toggle('is-open', open);
      el.classList.toggle('is-closed', !open);
    });

    const drawer = document.querySelector('[data-drawer-status]');
    const label = document.querySelector('[data-drawer-status-label]');
    if (drawer) drawer.classList.toggle('is-closed', !open);
    if (label) label.textContent = open ? "We're open" : "We're closed";

    document.querySelectorAll('[data-start-order]').forEach((el) => {
      if (!el.dataset.fixedLabel) {
        el.textContent = open ? 'Start ordering' : 'Browse menu';
      }
    });
  }

  function showClosedNotice() {
    let root = document.querySelector('[data-closed-modal]');
    if (!root) {
      const wrap = document.createElement('div');
      wrap.innerHTML = `
        <div class="closed-backdrop" data-closed-backdrop hidden></div>
        <div class="closed-modal" data-closed-modal role="dialog" aria-modal="true" hidden>
          <button type="button" class="closed-modal__close" data-closed-close aria-label="Close">×</button>
          <p class="closed-modal__badge">We're closed</p>
          <h2>Kitchen is offline</h2>
          <p class="closed-modal__lead">You can browse the full menu — adding to basket unlocks when we open.</p>
          <div class="closed-modal__hours"><span>Opens at</span><strong>${formatHour(cfg.openFrom ?? 12)}</strong></div>
          <button type="button" class="btn btn--primary" data-closed-close>Got it</button>
        </div>`;
      document.body.appendChild(wrap);
      root = wrap.querySelector('[data-closed-modal]');
      const backdrop = wrap.querySelector('[data-closed-backdrop]');
      const close = () => {
        root.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        setTimeout(() => {
          root.hidden = true;
          backdrop.hidden = true;
        }, 250);
      };
      wrap.querySelectorAll('[data-closed-close]').forEach((b) => b.addEventListener('click', close));
      backdrop.addEventListener('click', close);
    }
    const backdrop = document.querySelector('[data-closed-backdrop]');
    root.hidden = false;
    backdrop.hidden = false;
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      backdrop.classList.add('is-open');
    });
  }

  function requireOpen(e) {
    if (!cfg.blockWhenClosed || isOpenNow()) return true;
    if (e) e.preventDefault();
    showClosedNotice();
    return false;
  }

  function mountNav() {
    const panel = document.querySelector('[data-nav-drawer]');
    const backdrop = document.querySelector('[data-nav-backdrop]');
    const openBtn = document.querySelector('[data-nav-open]');
    if (!panel || !openBtn) return;

    function setOpen(on) {
      if (on) {
        panel.hidden = false;
        backdrop.hidden = false;
        requestAnimationFrame(() => {
          panel.classList.add('is-open');
          backdrop.classList.add('is-open');
        });
      } else {
        panel.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        setTimeout(() => {
          if (!panel.classList.contains('is-open')) {
            panel.hidden = true;
            backdrop.hidden = true;
          }
        }, 280);
      }
      document.documentElement.classList.toggle('nav-open', on);
    }

    openBtn.addEventListener('click', () => setOpen(true));
    backdrop?.addEventListener('click', () => setOpen(false));
    panel.querySelector('[data-nav-close]')?.addEventListener('click', () => setOpen(false));
  }

  function mountHomeSlider() {
    const root = document.querySelector('[data-home-slider]');
    if (!root) return;
    const slides = [...root.querySelectorAll('.home-slider__slide')];
    if (slides.length < 2) return;
    let i = 0;
    let timer = null;
    function go(next) {
      i = ((next % slides.length) + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
    }
    function play() {
      clearInterval(timer);
      timer = setInterval(() => go(i + 1), 4000);
    }
    go(0);
    play();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearInterval(timer);
      else play();
    });
  }

  const ORDER_TYPE_KEY = 'zaks_order_type';
  const DELIV_CHECK_KEY = 'zaks_delivery_check';

  function getOrderType() {
    return localStorage.getItem(ORDER_TYPE_KEY) || 'delivery';
  }

  function setOrderType(type) {
    localStorage.setItem(ORDER_TYPE_KEY, type);
    document.dispatchEvent(new CustomEvent('zaks:order-type', { detail: { type } }));
  }

  function getDeliveryCheck() {
    try {
      return JSON.parse(localStorage.getItem(DELIV_CHECK_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function setDeliveryCheck(data) {
    if (!data) localStorage.removeItem(DELIV_CHECK_KEY);
    else localStorage.setItem(DELIV_CHECK_KEY, JSON.stringify(data));
    document.dispatchEvent(new CustomEvent('zaks:delivery-check', { detail: data }));
  }

  function deliveryCfg() {
    return cfg.delivery || {};
  }

  function parseMoneySetting(val) {
    const n = parseFloat(String(val == null ? '' : val).replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  function deliveryZones() {
    const d = deliveryCfg();
    const defaults = [
      { id: 1, name: 'Zone 1', upto: 1, minimum: 15, fee: 2.49 },
      { id: 2, name: 'Zone 2', upto: 3, minimum: 20, fee: 3.99 },
      { id: 3, name: 'Zone 3', upto: 4, minimum: 30, fee: 4.99 },
    ];
    const raw = Array.isArray(d.zones) && d.zones.length ? d.zones : defaults;
    return raw
      .map((z, i) => ({
        id: z.id || i + 1,
        name: z.name || 'Zone ' + (i + 1),
        upto: parseMoneySetting(z.upto),
        minimum: parseMoneySetting(z.minimum),
        fee: parseMoneySetting(z.fee),
      }))
      .sort((a, b) => a.upto - b.upto);
  }

  function maxDeliveryMiles() {
    const zones = deliveryZones();
    return zones.length ? zones[zones.length - 1].upto : 4;
  }

  function resolveDeliveryZone(miles) {
    const m = Number(miles);
    if (!Number.isFinite(m) || m < 0) return null;
    const zones = deliveryZones();
    for (let i = 0; i < zones.length; i++) {
      if (m <= zones[i].upto + 0.001) return zones[i];
    }
    return null; // beyond last zone
  }

  function activeDeliveryZone() {
    const check = getDeliveryCheck();
    if (!check || !check.inZone) return null;
    if (check.zone) return check.zone;
    return resolveDeliveryZone(check.miles);
  }

  function haversineMiles(lat1, lon1, lat2, lon2) {
    const toRad = (d) => (d * Math.PI) / 180;
    const R = 3958.7613;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  async function lookupUkPostcode(postcode) {
    const clean = String(postcode || '').trim().toUpperCase().replace(/\s+/g, '');
    if (!clean) throw new Error('Enter a postcode');
    const spaced = clean.replace(/^(.+?)(\d[A-Z]{2})$/, '$1 $2');
    const res = await fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(spaced));
    const data = await res.json();
    if (!res.ok || !data || !data.result) {
      throw new Error((data && data.error) || 'Postcode not found');
    }
    return data.result;
  }

  function mountOrderType() {
    const buttons = Array.from(document.querySelectorAll('[data-order-type]'));
    const deliveryEnabled = cfg.enableDelivery !== false && cfg.enableDelivery !== 'false';
    const collectionEnabled = cfg.enableCollection !== false && cfg.enableCollection !== 'false';

    function labelFor(type) {
      if (type === 'collection') {
        return (cfg.collectionLabel || 'Collection') + ' · ' + (cfg.collectionEta || document.body.dataset.collectionEta || '15–25 mins');
      }
      return (cfg.deliveryLabel || 'Delivery') + ' · ' + (cfg.deliveryEta || document.body.dataset.deliveryEta || '25–40 mins');
    }

    let current;
    if (deliveryEnabled && !collectionEnabled) current = 'delivery';
    else if (collectionEnabled && !deliveryEnabled) current = 'collection';
    else {
      current = getOrderType();
      if (current !== 'delivery' && current !== 'collection') {
        current = deliveryEnabled ? 'delivery' : 'collection';
      }
    }

    function apply(type) {
      current = type;
      setOrderType(type);
      document.querySelectorAll('[data-type-line]').forEach((el) => {
        el.textContent = labelFor(type);
      });
      document.querySelectorAll('[data-order-type]').forEach((btn) => {
        const enabled =
          (btn.dataset.orderType === 'delivery' && deliveryEnabled) ||
          (btn.dataset.orderType === 'collection' && collectionEnabled);
        const on = enabled && btn.dataset.orderType === type;
        btn.disabled = !enabled;
        btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      syncOrderInfoNotes(type);
      syncDeliveryCheckers(type);
    }

    window.ZaksSetOrderType = apply;
    apply(current);

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        apply(btn.dataset.orderType);
      });
    });
  }

  function syncOrderInfoNotes(type) {
    const d = deliveryCfg();
    const text =
      type === 'collection'
        ? d.collectionNote || 'Estimated collection: 15–25 minutes.'
        : d.infoNote ||
          'Estimated delivery: 25–40 minutes. Delivery times may vary during busy periods.';
    document.querySelectorAll('[data-order-info-note]').forEach((el) => {
      const show = type === 'collection' || (type === 'delivery' && getDeliveryCheck() && getDeliveryCheck().inZone);
      el.hidden = !show;
      el.textContent = text;
    });
  }

  async function syncCartAttributes(type, check) {
    try {
      const attrs = {
        'Order type': type === 'collection' ? 'Collection' : 'Delivery',
      };
      if (type === 'delivery' && check && check.postcode) {
        attrs['Delivery postcode'] = check.postcode;
        attrs['Delivery distance (miles)'] = String(check.miles.toFixed(2));
        attrs['In delivery zone'] = check.inZone ? 'Yes' : 'No';
        attrs['Delivery zone'] = check.zone ? check.zone.name : 'Outside';
        attrs['Delivery fee'] = check.zone ? String(check.zone.fee) : '';
        attrs['Delivery minimum'] = check.zone ? String(check.zone.minimum) : '';
      } else {
        attrs['Delivery postcode'] = '';
        attrs['Delivery distance (miles)'] = '';
        attrs['In delivery zone'] = '';
        attrs['Delivery zone'] = '';
        attrs['Delivery fee'] = '';
        attrs['Delivery minimum'] = '';
      }
      await fetch(((cfg.routes && cfg.routes.cart) || '/cart') + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
      });
    } catch (e) {}
  }

  function formatPound(n) {
    return moneyFromCents(Math.round(Number(n) * 100));
  }

  let deliveryUiToken = 0;

  function clearDeliveryOnlyUI() {
    document.querySelectorAll('[data-deliv-minbox]').forEach((box) => {
      box.hidden = true;
    });
    document.querySelectorAll('[data-deliv-fee-row]').forEach((row) => {
      row.hidden = true;
    });
    document.querySelectorAll('[data-checkout-block-msg]').forEach((msg) => {
      msg.hidden = true;
      msg.textContent = '';
    });
    document.querySelectorAll('[data-checkout-btn]').forEach((btn) => {
      btn.disabled = false;
      btn.setAttribute('aria-disabled', 'false');
      btn.classList.remove('is-blocked');
    });
  }

  async function updateDeliveryMinimumUI(cartTotalCents, forcedType) {
    const token = ++deliveryUiToken;
    const check = getDeliveryCheck();
    const type = forcedType || getOrderType();
    const zone = activeDeliveryZone();
    const min = zone ? zone.minimum : 0;
    const fee = zone ? zone.fee : 0;
    const total = (Number(cartTotalCents) || 0) / 100;
    const remaining = Math.max(0, min - total);
    const pct = min > 0 ? Math.min(100, Math.round((total / min) * 100)) : 100;
    const qualifies = !!zone && total >= min - 0.001;
    const showDeliveryBits = type === 'delivery' && check && check.inZone && zone;

    if (token !== deliveryUiToken) return;

    if (!showDeliveryBits) {
      clearDeliveryOnlyUI();
      return;
    }

    document.querySelectorAll('[data-deliv-minbox]').forEach((box) => {
      box.hidden = false;
      const msg = box.querySelector('[data-deliv-min-msg]');
      const sub = box.querySelector('[data-deliv-min-sub]');
      const bar = box.querySelector('[data-deliv-bar]');
      if (qualifies) {
        if (msg) {
          msg.textContent =
            'Great — you’ve reached the ' + zone.name + ' minimum of ' + formatPound(min) + '.';
        }
        if (sub) sub.textContent = zone.name + ' delivery charge: ' + formatPound(fee);
      } else {
        if (msg) {
          msg.textContent =
            'Your minimum delivery order is ' +
            formatPound(min) +
            ' (' +
            zone.name +
            '). Please add another ' +
            formatPound(remaining) +
            ' to qualify for delivery.';
        }
        if (sub) {
          sub.textContent =
            Math.max(0, pct) + '% of minimum · ' + zone.name + ' delivery ' + formatPound(fee);
        }
      }
      if (bar) bar.style.width = pct + '%';
      box.classList.toggle('is-ok', qualifies);
      box.classList.toggle('is-short', !qualifies);
    });

    document.querySelectorAll('[data-deliv-fee-row]').forEach((row) => {
      row.hidden = false;
      const amt = row.querySelector('[data-deliv-fee-amount]');
      if (amt) amt.textContent = formatPound(fee);
    });
  }

  function syncDeliveryCheckers(type) {
    const d = deliveryCfg();
    const enabled = d.enabled !== false && cfg.enableDelivery !== false;
    const check = getDeliveryCheck();

    // Collection: hide fee + min warning + unblock checkout immediately
    if (type !== 'delivery') {
      document.querySelectorAll('[data-delivery-checker]').forEach((root) => {
        root.hidden = true;
      });
      clearDeliveryOnlyUI();
      syncOrderInfoNotes(type);
      syncCartAttributes(type, check);
      syncCheckoutGate(type);
      return;
    }

    document.querySelectorAll('[data-delivery-checker]').forEach((root) => {
      if (!enabled) {
        root.hidden = true;
        return;
      }
      // Show checker UI whenever delivery is selected
      root.hidden = false;

      const form = root.querySelector('[data-deliv-form]');
      const result = root.querySelector('[data-deliv-result]');
      const status = root.querySelector('[data-deliv-status]');
      const meta = root.querySelector('[data-deliv-meta]');
      const info = root.querySelector('[data-deliv-info]');
      const outsideActions = root.querySelector('[data-deliv-outside-actions]');
      const changeBtn = root.querySelector('[data-deliv-change]');
      const input = root.querySelector('[data-deliv-postcode]');

      if (!check) {
        if (form) form.hidden = false;
        if (result) result.hidden = true;
        return;
      }

      if (form) form.hidden = true;
      if (result) result.hidden = false;
      if (changeBtn) changeBtn.hidden = false;
      if (input) input.value = check.postcode || '';

      if (check.inZone && check.zone) {
        const zone = check.zone;
        if (status) {
          status.textContent = 'We deliver to ' + check.postcode + ' (' + zone.name + ').';
          status.className = 'deliv-check__status is-ok';
        }
        if (meta) {
          meta.hidden = false;
          meta.textContent =
            'About ' +
            check.miles.toFixed(1) +
            ' miles away · ' +
            zone.name +
            ' delivery ' +
            formatPound(zone.fee) +
            ' · Min order ' +
            formatPound(zone.minimum);
        }
        if (info) {
          info.hidden = false;
          info.textContent =
            d.infoNote ||
            'Estimated delivery: 25–40 minutes. Delivery times may vary during busy periods.';
        }
        if (outsideActions) outsideActions.hidden = true;
      } else {
        if (status) {
          status.textContent =
            d.outsideMessage ||
            "Sorry, we don't currently deliver to your area. Our delivery service covers up to 4 miles, but you can still order online for collection!";
          status.className = 'deliv-check__status is-out';
        }
        if (meta) {
          meta.hidden = false;
          meta.textContent =
            check.postcode +
            ' is about ' +
            check.miles.toFixed(1) +
            ' miles away (we deliver up to ' +
            maxDeliveryMiles() +
            ' miles).';
        }
        if (info) info.hidden = true;
        if (outsideActions) outsideActions.hidden = false;
      }
    });

    syncOrderInfoNotes(type);
    getCart()
      .then((cart) => updateDeliveryMinimumUI(cart.total_price, type))
      .catch(() => updateDeliveryMinimumUI(0, type));
    syncCartAttributes(type, check);
    syncCheckoutGate(type);
  }

  async function runPostcodeCheck(rawPostcode) {
    const d = deliveryCfg();
    const place = await lookupUkPostcode(rawPostcode);
    const shopLat = parseFloat(d.shopLat);
    const shopLng = parseFloat(d.shopLng);
    const miles = haversineMiles(shopLat, shopLng, place.latitude, place.longitude);
    const zone = resolveDeliveryZone(miles);
    const payload = {
      postcode: place.postcode,
      miles,
      inZone: !!zone,
      zone: zone
        ? { id: zone.id, name: zone.name, upto: zone.upto, minimum: zone.minimum, fee: zone.fee }
        : null,
      lat: place.latitude,
      lng: place.longitude,
    };
    setDeliveryCheck(payload);
    syncDeliveryCheckers(getOrderType());
    return payload;
  }

  function mountDeliveryChecker() {
    if (deliveryCfg().enabled === false) return;

    document.querySelectorAll('[data-delivery-checker]').forEach((root) => {
      const input = root.querySelector('[data-deliv-postcode]');
      const submit = root.querySelector('[data-deliv-submit]');
      const changeBtn = root.querySelector('[data-deliv-change]');

      async function doCheck() {
        if (!input) return;
        const prev = submit ? submit.textContent : '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Checking…';
        }
        try {
          await runPostcodeCheck(input.value);
        } catch (err) {
          const status = root.querySelector('[data-deliv-status]');
          const form = root.querySelector('[data-deliv-form]');
          const result = root.querySelector('[data-deliv-result]');
          if (form) form.hidden = true;
          if (result) result.hidden = false;
          if (status) {
            status.className = 'deliv-check__status is-out';
            status.textContent = err.message || 'Could not check that postcode.';
          }
          const outsideActions = root.querySelector('[data-deliv-outside-actions]');
          if (outsideActions) outsideActions.hidden = true;
          const change = root.querySelector('[data-deliv-change]');
          if (change) change.hidden = false;
        } finally {
          if (submit) {
            submit.disabled = false;
            submit.textContent = prev || 'Check';
          }
        }
      }

      if (submit) submit.addEventListener('click', doCheck);
      if (input) {
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            doCheck();
          }
        });
      }
      if (changeBtn) {
        changeBtn.addEventListener('click', () => {
          setDeliveryCheck(null);
          syncDeliveryCheckers(getOrderType());
        });
      }
    });

    document.querySelectorAll('[data-switch-collection]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (window.ZaksSetOrderType) window.ZaksSetOrderType('collection');
      });
    });

    document.addEventListener('zaks:order-type', (e) => {
      syncDeliveryCheckers(e.detail.type);
    });
  }

  async function evaluateDeliveryCheckoutBlock(forcedType) {
    const type = forcedType || getOrderType();
    const check = getDeliveryCheck();
    const d = deliveryCfg();
    const zone = activeDeliveryZone();

    if (type !== 'delivery' || d.enabled === false || cfg.enableDelivery === false) {
      return { blocked: false, message: '' };
    }
    if (!check) {
      return { blocked: true, message: 'Enter your delivery postcode before checkout.' };
    }
    if (!check.inZone || !zone) {
      return {
        blocked: true,
        message: 'We don’t deliver to that area — switch to Collection to continue.',
      };
    }
    try {
      const cart = await getCart();
      const total = (cart.total_price || 0) / 100;
      if (total < zone.minimum) {
        return {
          blocked: true,
          message:
            'Add another ' +
            formatPound(zone.minimum - total) +
            ' to reach the ' +
            zone.name +
            ' minimum of ' +
            formatPound(zone.minimum) +
            ' — or switch to Collection.',
        };
      }
    } catch (e) {}
    return { blocked: false, message: '' };
  }

  let checkoutGateToken = 0;

  async function syncCheckoutGate(forcedType) {
    const type = forcedType || getOrderType();
    const token = ++checkoutGateToken;

    // Collection: clear gate UI immediately (don't wait on cart fetch)
    if (type !== 'delivery') {
      clearDeliveryOnlyUI();
      return;
    }

    const gate = await evaluateDeliveryCheckoutBlock(type);
    if (token !== checkoutGateToken) return; // stale response after switch
    if (getOrderType() !== 'delivery') {
      clearDeliveryOnlyUI();
      return;
    }

    document.querySelectorAll('[data-checkout-btn]').forEach((btn) => {
      btn.disabled = gate.blocked;
      btn.setAttribute('aria-disabled', gate.blocked ? 'true' : 'false');
      btn.classList.toggle('is-blocked', gate.blocked);
      const form = btn.closest('form');
      const msg =
        (form && form.querySelector('[data-checkout-block-msg]')) ||
        (btn.parentElement && btn.parentElement.querySelector('[data-checkout-block-msg]'));
      if (msg) {
        msg.hidden = !gate.blocked;
        msg.textContent = gate.message;
      }
    });
  }

  function mountCheckoutGate() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-checkout-btn]');
      if (!btn) return;
      const gate = await evaluateDeliveryCheckoutBlock();
      if (gate.blocked) {
        e.preventDefault();
        e.stopPropagation();
        syncCheckoutGate();
        alert(gate.message);
      }
    }, true);

    document.querySelectorAll('[data-checkout-form]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        const gate = await evaluateDeliveryCheckoutBlock();
        if (gate.blocked) {
          e.preventDefault();
          syncCheckoutGate();
          alert(gate.message);
        }
      });
    });
  }

  function mountHomeMenuScroll() {
    document.querySelectorAll('[data-scroll-menu]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const href = btn.getAttribute('href') || '';
        if (href.startsWith('#')) {
          const target = document.querySelector('[data-home-menu]') || document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });
  }

  function mountTypeFilter() {
    const list = document.querySelector('[data-products]');
    if (!list) return;
    const ptype = new URLSearchParams(window.location.search).get('ptype');
    if (!ptype) return;

    let n = 0;
    list.querySelectorAll('.product-wrap').forEach((wrap) => {
      const card = wrap.querySelector('[data-product-type]');
      const t = (card && card.getAttribute('data-product-type')) || '';
      if (t.toLowerCase() === ptype.toLowerCase()) {
        n += 1;
      } else {
        wrap.hidden = true;
      }
    });

    const title = document.querySelector('[data-collection-title]');
    const count = document.querySelector('[data-collection-count]');
    const pager = document.querySelector('[data-collection-pagination]');
    if (title) title.textContent = ptype;
    if (count) count.textContent = n + (n === 1 ? ' item' : ' items');
    if (pager) pager.hidden = true;

    if (n === 0) {
      const empty = document.createElement('li');
      empty.className = 'empty';
      empty.innerHTML = '<p>No products in this category yet.</p>';
      list.appendChild(empty);
    }
  }

  function cartAddUrl() {
    const base = (cfg.routes && cfg.routes.cartAdd) || '/cart/add';
    return base.endsWith('.js') ? base : base + '.js';
  }

  async function refreshCartDock() {
    const dock = document.querySelector('[data-dock]');
    if (!dock) return false;
    try {
      const cart = await getCart();
      const count = Number(cart.item_count) || 0;
      const totalEl = dock.querySelector('[data-basket-total]');
      const countEl = dock.querySelector('[data-basket-count]');
      if (totalEl) totalEl.textContent = moneyFromCents(cart.total_price);
      if (countEl) countEl.textContent = String(count);
      const label = dock.querySelector('span');
      if (label && countEl) {
        // Keep "X items" wording after the count span
        const itemWord = count === 1 ? 'item' : 'items';
        label.innerHTML = `<span data-basket-count>${count}</span> ${itemWord}`;
      }
      dock.hidden = count === 0;
      document.body.classList.toggle('has-cart-dock', count > 0);
      if (count > 0) {
        dock.classList.remove('is-pulse');
        void dock.offsetWidth;
        dock.classList.add('is-pulse');
      }
      await updateDeliveryMinimumUI(cart.total_price);
      syncCheckoutGate();
      return true;
    } catch (e) {
      return false;
    }
  }

  async function refreshLiveCart(options) {
    const opts = options || {};
    // Always refresh mobile dock first
    await refreshCartDock();

    const root = document.querySelector('[data-live-cart]');
    if (!root) return false;

    const scrollEl = root.querySelector('.live-cart__scroll');
    const prevScroll = scrollEl ? scrollEl.scrollTop : 0;

    const sectionEl =
      root.closest('[id^="shopify-section-"]') || document.getElementById('shopify-section-live-cart');
    const sectionId = sectionEl ? sectionEl.id.replace(/^shopify-section-/, '') : 'live-cart';
    const pathRoot = (cfg.routes && cfg.routes.root) || '/';
    const url = `${pathRoot}?sections=${encodeURIComponent(sectionId)}`;

    try {
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return false;
      const data = await res.json();
      const html = data[sectionId];
      if (!html) return false;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshSection = doc.getElementById(`shopify-section-${sectionId}`);
      const freshCart = doc.querySelector('[data-live-cart]');

      if (sectionEl && freshSection) {
        sectionEl.innerHTML = freshSection.innerHTML;
      } else if (freshCart) {
        root.replaceWith(freshCart);
      }

      const cart = document.querySelector('[data-live-cart]');
      if (cart) {
        if (opts.pulse !== false) {
          cart.classList.remove('is-pulse');
          void cart.offsetWidth;
          cart.classList.add('is-pulse');
        }
        const scroll = cart.querySelector('.live-cart__scroll');
        if (scroll && opts.keepScroll) scroll.scrollTop = prevScroll;
      }

      document.querySelector('.main')?.classList.add('has-live-cart');
      document.body.classList.add('has-live-cart');
      return true;
    } catch (e) {
      return false;
    }
  }

  function cartChangeUrl() {
    const base = (cfg.routes && cfg.routes.cartChange) || '/cart/change';
    return base.endsWith('.js') ? base : base + '.js';
  }

  function cartJsUrl() {
    return (cfg.routes && cfg.routes.cartJs) || '/cart.js';
  }

  function cartUpdateUrl() {
    const cart = (cfg.routes && cfg.routes.cart) || '/cart';
    return cart.endsWith('.js') ? cart.replace(/\.js$/, '') + '/update.js' : cart + '/update.js';
  }

  async function getCart() {
    const res = await fetch(cartJsUrl(), { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Could not load basket');
    return res.json();
  }

  async function changeCartLine(key, quantity) {
    const cart = await getCart();
    const item = (cart.items || []).find((i) => i.key === key);
    const group = item && item.properties && item.properties._group;
    const qty = Number(quantity);

    if (group) {
      const updates = {};
      const pizzaQty = item.quantity || 1;
      (cart.items || []).forEach((i) => {
        if (!(i.properties && i.properties._group === group)) return;
        if (i.key === key) {
          updates[i.key] = qty;
        } else if (qty <= 0) {
          updates[i.key] = 0;
        } else {
          const per = Number(i.properties._per_pizza);
          if (!Number.isNaN(per) && per >= 0) {
            updates[i.key] = Math.round(per * qty);
          } else {
            const ratio = pizzaQty > 0 ? i.quantity / pizzaQty : i.quantity;
            updates[i.key] = Math.max(0, Math.round(ratio * qty));
          }
        }
      });
      const res = await fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!res.ok) throw new Error('Could not update basket');
      return res.json();
    }

    const res = await fetch(cartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    if (!res.ok) {
      let msg = 'Could not update basket';
      try {
        const err = await res.json();
        if (err.description) msg = err.description;
      } catch (e) {}
      throw new Error(msg);
    }
    return res.json();
  }

  async function loadPizzaFees(extras) {
    if (!extras) return extras;
    const root = (cfg.routes && cfg.routes.root) || '/';

    if (!extras.toppingFee) {
      try {
        const handle = extras.toppingHandle || 'extra-pizza-topping';
        const res = await fetch(`${root}products/${handle}.js`);
        if (res.ok) {
          const p = await res.json();
          extras.toppingFee = {
            variants: (p.variants || []).map((v) => ({
              id: v.id,
              option1: v.option1 || (v.options && v.options[0]) || '',
              price: v.price,
            })),
          };
        }
      } catch (e) {}
    }

    if (!extras.dipFee) {
      try {
        const handle = extras.dipHandle || 'pizza-dip-pack';
        const res = await fetch(`${root}products/${handle}.js`);
        if (res.ok) {
          const p = await res.json();
          const v = (p.variants || [])[0];
          if (v) extras.dipFee = { variantId: v.id, price: v.price };
        }
      } catch (e) {}
    }

    if (!extras.stuffedFee) {
      try {
        const handle = extras.stuffedHandle || 'stuffed-crust';
        const res = await fetch(`${root}products/${handle}.js`);
        if (res.ok) {
          const p = await res.json();
          extras.stuffedFee = {
            variants: (p.variants || []).map((v) => ({
              id: v.id,
              option1: v.option1 || (v.options && v.options[0]) || '',
              price: v.price,
            })),
          };
        }
      } catch (e) {}
    }

    return extras;
  }

  function mountLiveCartControls() {
    if (mountLiveCartControls.bound) return;
    mountLiveCartControls.bound = true;

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-qty]');
      if (!btn) return;
      e.preventDefault();

      const key = btn.getAttribute('data-key');
      const quantity = Number(btn.getAttribute('data-qty'));
      if (!key || Number.isNaN(quantity)) return;

      btn.disabled = true;
      const line = btn.closest('[data-cart-line], .cart-line');
      if (line) line.classList.add('is-updating');

      try {
        await changeCartLine(key, quantity);
        if (document.querySelector('[data-live-cart]')) {
          await refreshLiveCart({ pulse: quantity === 0, keepScroll: true });
        } else {
          window.location.reload();
        }
      } catch (err) {
        btn.disabled = false;
        if (line) line.classList.remove('is-updating');
        alert(err.message || 'Could not update basket');
      }
    });
  }

  async function addItemsToCart(items) {
    const res = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      let msg = 'Could not add to basket';
      try {
        const err = await res.json();
        if (err.description) msg = err.description;
      } catch (e) {}
      throw new Error(msg);
    }
    return res.json();
  }

  function moneyFromCents(cents) {
    const n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'GBP' }).format(n);
    } catch (e) {
      return '£' + n.toFixed(2);
    }
  }

  function pizzaSizeNum(label) {
    const m = String(label || '').match(/(\d+)/);
    return m ? m[1] : '';
  }

  function mountQuickAdd() {
    if (mountQuickAdd.bound) return;
    mountQuickAdd.bound = true;

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (!requireOpen(e)) return;

      const variantId = Number(btn.getAttribute('data-variant-id'));
      if (!variantId) return;

      const prev = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-adding');
      btn.textContent = '…';

      try {
        await addItemsToCart([{ id: variantId, quantity: 1 }]);
        await refreshLiveCart({ pulse: true });
        await refreshCartDock();
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        btn.textContent = '✓';
        setTimeout(() => {
          btn.textContent = prev || '+';
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1000);
      } catch (err) {
        btn.disabled = false;
        btn.classList.remove('is-adding');
        btn.textContent = prev || '+';
        alert(err.message || 'Could not add to basket');
      }
    });
  }

  function mountProductForm() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    const qtyInput = form.querySelector('[data-qty-input]');
    const qtyVal = form.querySelector('[data-qty-val]');
    const priceEl = document.querySelector('[data-product-price]');
    const addBtn = form.querySelector('[data-add-cart]');
    const jsonEl = document.querySelector('[data-product-json]');
    const extrasEl = document.querySelector('[data-pizza-extras-json]');
    let product = null;
    let extras = null;
    try {
      if (jsonEl) product = JSON.parse(jsonEl.textContent);
    } catch (e) {}
    try {
      if (extrasEl) extras = JSON.parse(extrasEl.textContent);
    } catch (e) {}

    let qty = 1;

    function selectedOptions() {
      const opts = {};
      form.querySelectorAll('[data-option-input]:checked').forEach((input) => {
        const m = input.name.match(/^options\[(.+)\]$/);
        if (m) opts[m[1]] = input.value;
      });
      return opts;
    }

    function isComboSelected() {
      const meal = String(selectedOptions().Meal || '');
      return /combo/i.test(meal);
    }

    function syncComboExtras() {
      const panel = form.querySelector('[data-combo-extras]');
      if (!panel) return;
      const on = isComboSelected();
      panel.hidden = !on;
      if (!on) {
        panel.querySelectorAll('[data-combo-choice]:checked').forEach((el) => {
          el.checked = false;
        });
      }
    }

    function kitchenProperties() {
      const props = {};
      form.querySelectorAll('[data-kitchen-choice]:checked').forEach((el) => {
        const key = el.getAttribute('data-kitchen');
        if (key && el.value) props[key] = el.value;
      });
      // Combo extras only when Combo meal is selected — never invent defaults
      if (isComboSelected()) {
        form.querySelectorAll('[data-combo-choice]:checked').forEach((el) => {
          const key = el.getAttribute('data-kitchen');
          if (key && el.value) props[key] = el.value;
        });
        if (props.Drink) props.Side = 'Chips';
      }
      const notes = form.querySelector('[data-kitchen-notes]');
      if (notes && notes.value.trim()) props['Special instructions'] = notes.value.trim();

      if (product && String(product.type || '') === 'Kids Meals') {
        const drink = props.Drink || selectedOptions().Drink || '';
        props['Main item'] = product.title;
        if (drink) {
          props.Side = 'Chips';
          props.Drink = drink;
        } else {
          delete props.Drink;
          delete props.Side;
        }
      }
      return props;
    }

    function missingKitchenChoices() {
      const missing = [];
      if (isComboSelected()) {
        if (!form.querySelector('[name="combo-drink"]:checked')) missing.push('combo drink');
        if (!form.querySelector('[name="combo-salt"]:checked')) missing.push('chips seasoning');
      }
      if (product && String(product.type || '') === 'Kids Meals') {
        const hasVariantDrink = !!selectedOptions().Drink;
        const hasKitchenDrink = !!form.querySelector('[name="kitchen-drink"]:checked');
        if (!hasVariantDrink && !hasKitchenDrink) missing.push('Fruit Shoot flavour');
      }
      if (product && String(product.type || '') === 'Burgers') {
        if (!form.querySelector('[name="kitchen-salad"]:checked')) missing.push('salad');
        if (!form.querySelector('[name="kitchen-cheese"]:checked')) missing.push('cheese');
        if (!form.querySelector('[name="kitchen-sauce"]:checked')) missing.push('sauce');
      }
      if (product && /donner|doner/i.test(String(product.type || ''))) {
        if (!form.querySelector('[name="kitchen-doner-salad"]:checked')) missing.push('salad');
        if (!form.querySelector('[name="kitchen-doner-sauce"]:checked')) missing.push('sauce');
      }
      if (form.querySelector('[name="kitchen-salt"]') && !form.querySelector('[name="kitchen-salt"]:checked')) {
        // only required when salt group is visible (fish/chips/sausage)
        missing.push('salt & vinegar');
      }
      if (form.querySelector('[name="kitchen-base"]') && !form.querySelector('[name="kitchen-base"]:checked')) {
        missing.push('pizza base');
      }
      if (product && String(product.type || '') === 'Pizza Deals') {
        const twoPizzas = !!form.querySelector('[name="kitchen-pizza-2"]');
        if (form.querySelector('[name="kitchen-pizza-1"]') && !form.querySelector('[name="kitchen-pizza-1"]:checked')) {
          missing.push(twoPizzas ? 'Pizza 1 flavour' : 'pizza flavour');
        }
        if (form.querySelector('[name="kitchen-pizza-1-base"]') && !form.querySelector('[name="kitchen-pizza-1-base"]:checked')) {
          missing.push(twoPizzas ? 'Pizza 1 base' : 'pizza base');
        }
        if (form.querySelector('[name="kitchen-pizza-2"]') && !form.querySelector('[name="kitchen-pizza-2"]:checked')) {
          missing.push('Pizza 2 flavour');
        }
        if (form.querySelector('[name="kitchen-pizza-2-base"]') && !form.querySelector('[name="kitchen-pizza-2-base"]:checked')) {
          missing.push('Pizza 2 base');
        }
      }
      return missing;
    }

    function findVariant() {
      if (!product || !product.variants) return null;
      const opts = selectedOptions();
      const names = product.options || [];
      return (
        product.variants.find((v) => names.every((name, i) => !opts[name] || v.options[i] === opts[name])) ||
        product.variants[0]
      );
    }

    function isPizzaDealProduct() {
      return product && String(product.type || '') === 'Pizza Deals';
    }

    function dealFallbackSize() {
      if (!product) return '9';
      const blob = String(product.title || '') + ' ' + String(product.description || '');
      if (/15/.test(blob)) return '15';
      if (/12/.test(blob)) return '12';
      if (/9/.test(blob)) return '9';
      return '9';
    }

    function toppingUnitCents() {
      const size = pizzaSizeNum(selectedOptions().Size) || pizzaSizeNum(dealFallbackSize());
      if (!extras || !extras.prices) return 100;
      return Number(extras.prices[size] || extras.prices['9'] || 100);
    }

    function pickedToppings() {
      return [...form.querySelectorAll('[data-pizza-topping]:checked')].map(
        (el) => el.getAttribute('data-topping-name') || el.value
      );
    }

    function selectedDip() {
      return form.querySelector('[data-pizza-dip]:checked');
    }

    function stuffedCrustCount() {
      let n = 0;
      form
        .querySelectorAll(
          '[name="kitchen-base"]:checked, [name="kitchen-pizza-1-base"]:checked, [name="kitchen-pizza-2-base"]:checked'
        )
        .forEach((el) => {
          if (/stuffed/i.test(el.value)) n += 1;
        });
      return n;
    }

    function stuffedUnitCents() {
      const size = pizzaSizeNum(selectedOptions().Size) || pizzaSizeNum(dealFallbackSize());
      const prices = (extras && extras.stuffedPrices) || { 9: 299, 12: 399, 15: 499 };
      return Number(prices[size] || prices['12'] || 399);
    }

    function extrasCents() {
      if (!extras) return 0;
      const tops = pickedToppings().length * toppingUnitCents();
      const dip = selectedDip();
      const dipCents = dip ? Number(dip.getAttribute('data-dip-price') || 0) : 0;
      const stuffed = stuffedCrustCount() * stuffedUnitCents();
      return tops + dipCents + stuffed;
    }

    function buttonLabel(totalCents) {
      return 'Add · ' + moneyFromCents(totalCents);
    }

    function refreshPizzaUI() {
      const variant = findVariant();
      const base = variant ? Number(variant.price) : 0;
      const extra = extras ? extrasCents() : 0;
      const unit = base + extra;
      const total = unit * qty;

      if (extras) {
        const topUnit = toppingUnitCents();
        form.querySelectorAll('[data-top-price]').forEach((el) => {
          el.hidden = false;
          el.textContent = topUnit > 0 ? '+' + moneyFromCents(topUnit) : 'Free';
        });
        const stuffedUnit = stuffedUnitCents();
        form.querySelectorAll('[data-stuffed-price]').forEach((el) => {
          el.textContent = '+' + moneyFromCents(stuffedUnit);
        });
      }

      if (priceEl) priceEl.textContent = moneyFromCents(unit);
      if (addBtn && !addBtn.disabled) {
        addBtn.textContent = buttonLabel(total);
      }
      const idInput = form.querySelector('[data-variant-id]');
      if (idInput && variant) idInput.value = variant.id;
      const heroImg = document.querySelector('.product-hero__media img');
      const vImg = variant && (variant.featured_image || variant.image);
      if (heroImg && vImg && (vImg.src || vImg)) {
        const src = typeof vImg === 'string' ? vImg : vImg.src;
        if (src) heroImg.src = src.includes('?') ? src : src + '&width=900';
      }
    }

    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      qty = Math.max(1, qty - 1);
      qtyInput.value = qty;
      if (qtyVal) qtyVal.textContent = String(qty);
      refreshPizzaUI();
    });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      qty = Math.min(20, qty + 1);
      qtyInput.value = qty;
      if (qtyVal) qtyVal.textContent = String(qty);
      refreshPizzaUI();
    });

    form.querySelectorAll('[data-option-input], [data-pizza-topping], [data-pizza-dip], [data-kitchen-choice], [data-combo-choice]').forEach((el) => {
      el.addEventListener('change', () => {
        syncComboExtras();
        refreshPizzaUI();
      });
    });
    syncComboExtras();

    form.addEventListener('submit', async (e) => {
      if (!requireOpen(e)) return;
      e.preventDefault();

      const variant = findVariant();
      if (!variant) return;

      const missing = missingKitchenChoices();
      if (missing.length) {
        alert('Please choose: ' + missing.join(', ') + '.');
        return;
      }

      const items = [];
      const properties = {};

      if (extras) {
        extras = await loadPizzaFees(extras);
        const tops = pickedToppings();
        const dip = selectedDip();
        const dipName = dip ? dip.value : 'No Dip';
        const dipCents = dip ? Number(dip.getAttribute('data-dip-price') || 0) : 0;
        const sizeLabel = selectedOptions().Size || (String(product.type || '') === 'Pizza Deals' ? dealFallbackSize() + '"' : '');
        const sizeNum = pizzaSizeNum(sizeLabel) || pizzaSizeNum(dealFallbackSize());
        const groupId = 'pz' + Date.now();

        if (tops.length && !(extras.toppingFee && extras.toppingFee.variants && extras.toppingFee.variants.length)) {
          alert(
            'Topping prices need the Extra pizza topping product.\n\nImport ZAKS_Pizza_Extras.csv in Shopify Admin → Products → Import, then try again.'
          );
          return;
        }
        if (dipCents > 0 && !(extras.dipFee && extras.dipFee.variantId)) {
          alert(
            'Dip prices need the Pizza dip pack product.\n\nImport ZAKS_Pizza_Extras.csv in Shopify Admin → Products → Import, then try again.'
          );
          return;
        }
        const stuffedCount = stuffedCrustCount();
        if (stuffedCount && !(extras.stuffedFee && extras.stuffedFee.variants && extras.stuffedFee.variants.length)) {
          alert('Stuffed crust needs the stuffed crust fee product. Try again in a moment.');
          return;
        }

        // Always print kitchen-readable options on the pizza line (shows in Shopify Admin order)
        if (sizeLabel) properties.Size = sizeLabel;
        properties['Extra toppings'] = tops.length ? tops.join(', ') : 'None';
        properties.Dip = dipName || 'No Dip';
        Object.assign(properties, kitchenProperties());
        properties._group = groupId;

        items.push({ id: variant.id, quantity: qty, properties });

        if (tops.length) {
          const feeVar =
            extras.toppingFee.variants.find((v) => pizzaSizeNum(v.option1) === sizeNum) ||
            extras.toppingFee.variants[0];
          if (feeVar) {
            items.push({
              id: feeVar.id,
              quantity: tops.length * qty,
              properties: {
                _group: groupId,
                _fee: 'topping',
                _per_pizza: String(tops.length),
                'For pizza': product.title,
                'Extra toppings': tops.join(', '),
                Size: sizeLabel,
              },
            });
          }
        }

        if (dipCents > 0) {
          items.push({
            id: extras.dipFee.variantId,
            quantity: qty,
            properties: {
              _group: groupId,
              _fee: 'dip',
              _per_pizza: '1',
              'For pizza': product.title,
              Dip: dipName,
            },
          });
        }

        if (stuffedCount) {
          const feeVar =
            extras.stuffedFee.variants.find((v) => pizzaSizeNum(v.option1) === String(sizeNum)) ||
            extras.stuffedFee.variants[0];
          if (feeVar) {
            items.push({
              id: feeVar.id,
              quantity: stuffedCount * qty,
              properties: {
                _group: groupId,
                _fee: 'stuffed-crust',
                'For pizza': product.title,
                Base: 'Stuffed Crust',
                Size: sizeLabel,
              },
            });
          }
        }
      } else {
        const props = kitchenProperties();
        if (Object.keys(props).length) {
          items.push({ id: variant.id, quantity: qty, properties: props });
        } else {
          items.push({ id: variant.id, quantity: qty });
        }
      }

      const restore = () => refreshPizzaUI();
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      try {
        await addItemsToCart(items);
        await refreshLiveCart();
        await refreshCartDock();
        addBtn.disabled = false;
        addBtn.textContent = 'Added ✓';
        setTimeout(restore, 1100);

        if (extras) {
          form.querySelectorAll('[data-pizza-topping]:checked').forEach((el) => {
            el.checked = false;
          });
          const noDip = form.querySelector('[data-pizza-dip][data-dip-price="0"]');
          if (noDip) noDip.checked = true;
          refreshPizzaUI();
        }
      } catch (err) {
        addBtn.disabled = false;
        restore();
        alert(err.message || 'Could not add to basket.');
      }
    });

    refreshPizzaUI();
  }

  function mountAllergyModal() {
    const modal = document.querySelector('[data-allergy-modal]');
    const backdrop = document.querySelector('[data-allergy-backdrop]');
    if (!modal || !backdrop) return;

    const openers = document.querySelectorAll('[data-allergy-open]');
    if (!openers.length) return;

    function setOpen(on) {
      if (on) {
        modal.hidden = false;
        backdrop.hidden = false;
        document.documentElement.classList.add('allergy-open');
        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          backdrop.classList.add('is-open');
        });
        // Close mobile drawer if open
        document.querySelector('[data-nav-drawer]')?.classList.remove('is-open');
        document.querySelector('[data-nav-backdrop]')?.classList.remove('is-open');
      } else {
        modal.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        document.documentElement.classList.remove('allergy-open');
        setTimeout(() => {
          if (!modal.classList.contains('is-open')) {
            modal.hidden = true;
            backdrop.hidden = true;
          }
        }, 250);
      }
    }

    openers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(true);
      });
    });

    modal.querySelectorAll('[data-allergy-close]').forEach((btn) => {
      btn.addEventListener('click', () => setOpen(false));
    });
    backdrop.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) setOpen(false);
    });
  }

  function mountOfferPromo() {
    const cfg = window.ZaksTheme?.offer || {};
    const bar = document.querySelector('[data-offer-bar]');
    const modal = document.querySelector('[data-offer-modal]');
    const backdrop = document.querySelector('[data-offer-backdrop]');
    if (!cfg.enable || (!bar && !modal)) return;

    const BAR_KEY = 'zaks_offer_bar_hide';
    const POP_KEY = 'zaks_offer_pop_seen';

    if (bar) {
      if (sessionStorage.getItem(BAR_KEY) === '1') {
        bar.hidden = true;
      } else {
        document.body.classList.add('has-offer-bar');
      }
      bar.querySelector('[data-offer-bar-dismiss]')?.addEventListener('click', () => {
        bar.hidden = true;
        document.body.classList.remove('has-offer-bar');
        sessionStorage.setItem(BAR_KEY, '1');
      });
    }

    if (!modal || !backdrop) return;

    const fireworks = document.querySelector('[data-offer-fireworks]');
    let fireworkFrame = 0;

    function stopFireworks() {
      fireworkFrame += 1;
      if (!fireworks) return;
      fireworks.hidden = true;
    }

    function playFireworks() {
      if (!fireworks || !document.body.classList.contains('template-index')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const run = ++fireworkFrame;
      const canvas = fireworks;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.hidden = false;
      canvas.width = Math.floor(window.innerWidth * dpr);
      canvas.height = Math.floor(window.innerHeight * dpr);
      const colors = ['#ff4500', '#ffb703', '#fff6e4', '#ff6a2a', '#ffe08a', '#ffd166'];
      const particles = [];
      const burst = (x, y) => {
        const count = 36;
        for (let i = 0; i < count; i += 1) {
          const angle = (Math.PI * 2 * i) / count + Math.random() * 0.25;
          const speed = 1.8 + Math.random() * 3.2;
          particles.push({
            x,
            y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            life: 1,
            decay: 0.012 + Math.random() * 0.012,
            color: colors[i % colors.length],
            size: 1.4 + Math.random() * 1.8
          });
        }
      };
      const w = window.innerWidth;
      const h = window.innerHeight;
      const shots = [
        [w * 0.2, h * 0.26],
        [w * 0.8, h * 0.22],
        [w * 0.5, h * 0.16],
        [w * 0.28, h * 0.68],
        [w * 0.74, h * 0.64]
      ];
      let frame = 0;
      const tick = () => {
        if (run !== fireworkFrame) return;
        frame += 1;
        if (frame === 1) burst(shots[0][0], shots[0][1]);
        if (frame === 14) burst(shots[1][0], shots[1][1]);
        if (frame === 28) burst(shots[2][0], shots[2][1]);
        if (frame === 42) burst(shots[3][0], shots[3][1]);
        if (frame === 54) burst(shots[4][0], shots[4][1]);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, w, h);
        particles.forEach((p) => {
          p.x += p.vx;
          p.y += p.vy;
          p.vy += 0.04;
          p.life -= p.decay;
        });
        for (let i = particles.length - 1; i >= 0; i -= 1) {
          const p = particles[i];
          if (p.life <= 0) {
            particles.splice(i, 1);
            continue;
          }
          ctx.globalAlpha = Math.max(p.life, 0);
          ctx.fillStyle = p.color;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.globalAlpha = 1;
        if (frame < 130 || particles.length) requestAnimationFrame(tick);
        else stopFireworks();
      };
      requestAnimationFrame(tick);
    }

    function setOpen(on) {
      if (on) {
        modal.hidden = false;
        backdrop.hidden = false;
        document.documentElement.classList.add('offer-open');
        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          backdrop.classList.add('is-open');
          playFireworks();
        });
      } else {
        stopFireworks();
        modal.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        document.documentElement.classList.remove('offer-open');
        setTimeout(() => {
          if (!modal.classList.contains('is-open')) {
            modal.hidden = true;
            backdrop.hidden = true;
          }
        }, 250);
      }
    }

    document.querySelectorAll('[data-offer-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(true);
      });
    });
    modal.querySelectorAll('[data-offer-close]').forEach((btn) => {
      btn.addEventListener('click', () => setOpen(false));
    });
    backdrop.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) setOpen(false);
    });

    modal.querySelector('[data-offer-copy]')?.addEventListener('click', async () => {
      const code = (modal.querySelector('[data-offer-code]')?.textContent || cfg.code || '').trim();
      try {
        await navigator.clipboard.writeText(code);
        const btn = modal.querySelector('[data-offer-copy]');
        if (btn) {
          const prev = btn.textContent;
          btn.textContent = 'Copied';
          setTimeout(() => { btn.textContent = prev; }, 1500);
        }
      } catch (_) {
        /* ignore */
      }
    });

    modal.querySelector('[data-offer-apply]')?.addEventListener('click', () => {
      sessionStorage.setItem(POP_KEY, '1');
    });

    const home = document.body.classList.contains('template-index');
    if (home && cfg.showPopup && sessionStorage.getItem(POP_KEY) !== '1') {
      setTimeout(() => {
        setOpen(true);
        sessionStorage.setItem(POP_KEY, '1');
      }, 900);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.remove('no-js');
    syncStatus();
    setInterval(syncStatus, 60000);
    mountNav();
    mountHomeSlider();
    mountOrderType();
    mountDeliveryChecker();
    mountCheckoutGate();
    mountHomeMenuScroll();
    mountTypeFilter();
    mountProductForm();
    mountQuickAdd();
    mountLiveCartControls();
    mountAllergyModal();
    mountOfferPromo();

    document.querySelectorAll('[data-add-cart], [data-checkout-btn]').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (el.matches('[data-checkout-btn]') && el.disabled) {
          e.preventDefault();
          return;
        }
        requireOpen(e);
      });
    });

    if (document.querySelector('[data-live-cart]')) {
      document.querySelector('.main')?.classList.add('has-live-cart');
      document.body.classList.add('has-live-cart');
    }

    // Sync mobile dock if cart already has items
    refreshCartDock();
  });
})();
